import { useState } from 'react';
import { Modal } from '../../../Modal';
import { Input } from '../../../Inputs/Input';
import { Button } from '../../../Button';
import { formRules } from '../../FormRules';
import { FormProvider, useForm } from 'react-hook-form';
import { apiService } from '../../../../services/api';
import { useToast } from '../../../../hooks';
import { AllSubjectsRes, Level } from '../../../../services/api.types';
import { CheckboxesTags, Option } from '../../../Inputs/Checkboxes';
import { translateSubjectLevel } from '../../../CalendarEvent';

type CreateSubjectProps = {
  open: boolean;
  onClose: () => void;
  onCreateSubject: (res: AllSubjectsRes) => void;
};

export type SubjectFormValues = {
  subjectName: string;
  subjectLevels: Option[];
};

const options = Object.values(Level).map((level) => ({
  id: level,
  label: translateSubjectLevel[level],
}));

const subjectDefaultValues: SubjectFormValues = {
  subjectName: '',
  subjectLevels: [],
};

export const CreateSubject = ({
  open,
  onClose,
  onCreateSubject,
}: CreateSubjectProps) => {
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const forms = useForm<SubjectFormValues>({
    mode: 'all',
    defaultValues: subjectDefaultValues,
  });

  const onSubmit = async (data: SubjectFormValues) => {
    setIsLoading(true);
    apiService
      .createSubject({
        name: data.subjectName,
        levels: data.subjectLevels.length
          ? data.subjectLevels.map(
              (level) => Level[level.id as keyof typeof Level]
            )
          : undefined,
      })
      .then((res) => {
        onCreateSubject(res);
        forms.reset(subjectDefaultValues);
        toast.success('Materia cadastrada!');
        setIsLoading(false);
        onClose();
      })
      .catch((error) => {
        toast.error('Erro ao cadastrar matéria');
        setIsLoading(false);
      });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <FormProvider {...forms}>
        <form onSubmit={forms.handleSubmit(onSubmit)} className="p-4 w-[480px]">
          <h3>Criar matéria</h3>
          <Input
            placeholder='Ex: "Matemática"'
            name="subjectName"
            label="Nome da Matéria"
            rules={formRules.subjectNameRequired}
          />
          <CheckboxesTags
            name="subjectLevels"
            label="Níveis"
            rules={formRules.levelRequired}
            options={options}
            placeholder="Selecione o(s) nível(s) de conhecimento:"
          />
          <div className="flex gap-4 justify-end pt-4">
            <Button
              size="small"
              circular
              fullWidth={false}
              onClick={() => {
                onClose();
              }}
            >
              Cancelar
            </Button>
            <Button
              isLoading={isLoading}
              type="submit"
              size="small"
              circular
              fullWidth={false}
            >
              Criar
            </Button>
          </div>
        </form>
      </FormProvider>
    </Modal>
  );
};
